import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'app/lib/hooks';
import { selectSetServiceAccountError } from 'app/store/jobs';
import { Button, ButtonSize } from 'app/components/core/Button';
import { Submit } from 'app/components/core/Form';
import {
    Dialog,
    ModalActions,
    ModalBody,
    ModalErrorBanner,
    ModalHeader,
    ModalTitle
} from 'app/components/core/Modal';
import { CreateServiceAccountForm } from './CreateServiceAccountForm.jsx';

const DIALOG_WIDTH = 650;

export function CreateServiceAccountDialog({ account = null, onClose = noop }) {
    const { t } = useTranslation();
    const error = useSelector(selectSetServiceAccountError);

    return (
        <Dialog onClose={onClose} width={DIALOG_WIDTH}>
            <ModalHeader>
                <ModalTitle>
                    {t('jobs:dialogs.serviceAccount.title', {
                        context: account ? 'edit' : 'create'
                    })}
                </ModalTitle>
            </ModalHeader>
            {error && <ModalErrorBanner error={error} />}
            <ModalBody>
                <CreateServiceAccountForm account={account} onSuccess={onClose}>
                    <ModalActions>
                        <Button onClick={onClose} size={ButtonSize.MEDIUM}>
                            {t('common:cancel')}
                        </Button>
                        <Submit size={ButtonSize.MEDIUM}>{t('common:apply')}</Submit>
                    </ModalActions>
                </CreateServiceAccountForm>
            </ModalBody>
        </Dialog>
    );
}

CreateServiceAccountDialog.propTypes = {
    account: PropTypes.shape({
        description: PropTypes.string,
        name: PropTypes.string.isRequired,
        uid: PropTypes.string,
        username: PropTypes.string.isRequired
    }),
    onClose: PropTypes.func
};
